export default "__VITE_ASSET__dc5a3b8a__"